import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { SavedJobsList } from '../../components/jobs/saved/SavedJobsList';
import { LoadingSpinner } from '../../components/common/LoadingSpinner';
import { useSavedItems } from '../../hooks/saved/useSavedItems';

export function SavedJobsPage() {
  const { isLoading } = useSavedItems();

  if (isLoading) {
    return (
      <div className="flex justify-center p-8">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-dark py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="mb-6">
          <Link
            to="/saved"
            className="inline-flex items-center text-accent-green hover:opacity-80"
          >
            <ArrowLeft className="h-5 w-5 mr-2" />
            Back to Saved Items
          </Link>
        </div>

        <div className="mb-8">
          <h1 className="text-2xl font-bold text-white">Saved Jobs</h1>
          <p className="mt-2 text-gray-400">Track and manage your saved job listings</p>
        </div>

        <div className="card">
          <SavedJobsList />
        </div>
      </div>
    </div>
  );
}